export default "__VITE_ASSET__C06Xp7pS__"